import React from 'react';
import EquipmentIcon from 'assets/equipment.svg?react';
import { EquipmentDropDownItemProps } from '../../types';

const EquipmentDropdownItem: React.FC<EquipmentDropDownItemProps> = ({
  item,
  hideIcon = false
}) => {
  const { value: itemValue, label } = item;
  if (!itemValue) {
    return (
      <div className="w-full h-full px-2 py-1 ml-2 flex items-center">
        <div>{label}</div>
      </div>
    );
  }

  return (
    <div
      className="w-full h-full px-2 py-1 ml-2 flex items-center"
      data-testid="item-with-value"
    >
      {!hideIcon && (
        <span>
          <EquipmentIcon />
        </span>
      )}

      <div className={hideIcon ? '' : 'pl-2'}>{itemValue.name}</div>
    </div>
  );
};

export default EquipmentDropdownItem;
